import { Injectable } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import Pusher from 'pusher-js';
import { environment } from '@env/environment';
import Utils from '@shared/utils/utils';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  private pusher = null;
  private bConnectionShown = false;
  private logEnabled = false;

  constructor(private authService: AuthService) {
    Pusher.logToConsole = false;
    this.logEnabled = !environment.production;

    const opts = {
      cluster: environment.pusher.cluster,
      authEndpoint: `${ environment.api.backend }${ environment.pusher.authEndpoint }`,
      auth: {
        headers: {
          Authorization: `Bearer ${ authService.getAccessToken() }`,
        }
      }
    };

    this.pusher = new Pusher(environment.pusher.appKey, opts);

    this.pusher.connection.bind('error', err => {
      this.pusherLog(`Error: ${ err }`, err);
    });

    this.pusher.connection.bind('state_change', states => {
      this.pusherLog(`status......${ states.current.toUpperCase() }`, states.current === 'unavailable');
      switch (states.current) {
        case 'unavailable':
          this.showConnectionError();
          console.log('The pusher server, one of back-end servers, is not reachable from your computer, and you may need to refresh your browser to see missing information.')
          break;
        default:
          break;
      }
    });

    const mask = (str, mask, s = 0, n = 1) => {
      return ('' + str).slice(0, s)
        + ('' + str).slice(0, -(n + s)).replace(/./g, mask)
        + ('' + str).slice(-n);
    }

    this.pusherLog(`connecting to pusher server with appKey: ${ mask(environment.pusher.appKey, '*', 1, 4) }`);
  }

  subscribe(channelName) {
    return new Promise(resolve => {
      let channel = this.pusher.subscribe(channelName);
      let tried = 0;
      if (!channelName.startsWith('private-')) {
        return resolve(channel);
      }

      channel.bind('pusher:subscription_error', error => {
        tried += 1;
        if (tried < 60) {
          // retry to connect
          this.pusherLog(error, true);
          setTimeout(() => {
            this.pusherLog('reconnecting pusher......');
            this.authService.getValidAccessTokenPromise()
              .then(token => {
                this.pusher.config.auth.headers.Authorization = `Bearer ${ token }`;
                channel = this.pusher.subscribe(channelName);
              })
              .catch(err => {
                return resolve(channel); // return failed channel
              });
          }, 1000 * tried);
        } else {
          resolve(channel); // return failed channel
        }
      });

      channel.bind('pusher:subscription_succeeded', () => {
        this.pusherLog(`private channel ${ channelName } now connected`);
        resolve(channel);
      });
    });
  }

  subscribePromise(channelName) {
    return new Promise(resolve => {
      var channel = this.pusher.subscribe(channelName);
      var tried = 0;
      if (!channelName.startsWith('private-')) {
        return resolve(channel);
      }

      channel.bind('pusher:subscription_error', error => {
        tried += 1;
        if (tried < 60) {
          // retry to connect
          this.pusherLog(error, true);
          setTimeout(() => {
            this.pusherLog('reconnecting pusher......');
            this.authService.getValidAccessTokenPromise()
              .then(token => {
                this.pusher.config.auth.headers.Authorization = `Bearer ${ token }`;
                channel = this.pusher.subscribe(channelName);
              })
              .catch(err => {
                return resolve(channel); // return failed channel
              });
          }, 1000 * tried);
        } else {
          resolve(channel); // return failed channel
        }
      });
      channel.bind('pusher:subscription_succeeded', () => {
        this.pusherLog(`private channel ${ channelName } now connected`);
        resolve(channel);
      });
    });
  }

  unsubscribe(channel) {
    return this.pusher.unsubscribe(channel);
  }

  // TODO 확인
  fixZonedDateTime(obj) {
    const pad = (num, size) => {
      num = num.toString();
      while (num.length < size) num = '0' + num;
      return num;
    }

    if (typeof obj === 'object') {
      if (obj.dateTime) {
        try {
          const { year, month, day } = obj.dateTime.date;
          const { hour, minute, second } = obj.dateTime.time;
          const zoneId = obj.zone.id;

          const str = `${ year }-${ pad(month, 2) }-${ pad(day, 2) }T${ pad(hour, 2) }:${ pad(minute, 2) }:${ pad(second, 2) }`;
          obj = moment.tz(str, zoneId).toISOString();
        } catch (err) {
          // ignore error
        }
      } else {
        Object.keys(obj).forEach(key => {
          obj[key] = this.fixZonedDateTime(obj[key])
        });
      }
    }

    return obj;
  }

  private pusherLog(msg, err = null) {
    if (!this.logEnabled) {
      return;
    }

    if (err) {
      console.error(`[PUSHER]`, err);
    } else {
      console.log(`[PUSHER] ${ msg }`);
    }
  }

  private showConnectionError() {
    if (!this.bConnectionShown) {
      this.bConnectionShown = true;
      const message = 'The pusher server, one of back-end servers, is not reachable from your computer, and you may need to refresh your browser to see missing information.';
      this.pusherLog(message);

      // Utils.showMessage(message);
    }
  }
}
